import React from 'react';
import { Link } from 'gatsby';

import StepsHeader from './WhatWeDoPartials/StepsHeader';
import StepsItem from './WhatWeDoPartials/StepsItem';

const Steps = () => {
  return (
    <div className="sub-steps" id="how-we-do">
      <div className="container">
        <StepsHeader />
        <div className="steps">
          <div className="row">
            <StepsItem
              number="1"
              header="Intro call"
              details="We’ll get to know each other and hear about your project to understand your needs. After the intro call, you’ll also know the general idea of delivery."
            />
            <StepsItem
              number="2"
              header="Discovery workshop"
              details="The second meeting is to get the details–deeper project understanding, setting the scope, requirements, and expected outcome."
            />
            <StepsItem
              number="3"
              header="Project kick-off"
              details="Once you decide to proceed, we’ll jump into planning the project roadmap with you."
            />
            <StepsItem
              number="4"
              header="Development"
              details="We use Agile and Scrum, so you’re always up to date on the progress."
            />
            <StepsItem
              number="5"
              header="Support and maintenance"
              details="After signing off the results, we’ll move to support and maintenance phase to make sure your system runs flawlessly."
            />
            <div className="col-lg-4 col-md-6">
              <div className="item last">
                <Link to="/how-we-work/" className="btn btn-main">
                  Read more
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Steps;
